(() => {
  if (window.__jockboxMobileDrawerAccordionBound) return;
  window.__jockboxMobileDrawerAccordionBound = true;
  document.documentElement.dataset.jockboxDrawerAccordion = 'bound';
  const preferredOpenItemByList = new WeakMap();

  const closeMenuItem = (menuItem) => {
    menuItem.classList.remove('is--opend');

    const directSubmenu = menuItem.querySelector(':scope > ul');
    if (directSubmenu) directSubmenu.style.display = 'none';

    menuItem.querySelectorAll('.t4s-menu-item-has-children.is--opend').forEach((childItem) => {
      childItem.classList.remove('is--opend');
      const childSubmenu = childItem.querySelector(':scope > ul');
      if (childSubmenu) childSubmenu.style.display = 'none';
    });
  };

  const showDirectSubmenu = (menuItem) => {
    const directSubmenu = menuItem.querySelector(':scope > ul');
    if (!directSubmenu) return;

    directSubmenu.style.display = 'block';
    ['height', 'overflow', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom'].forEach((property) => {
      directSubmenu.style.removeProperty(property);
    });
  };

  document.addEventListener('click', (event) => {
    const drawer = event.target.closest('.yo-mobile-drawer');
    if (!drawer) return;

    const toggle = event.target.closest('.t4s-menu-item-has-children > a, .t4s-menu-item-has-children > a .t4s-mb-nav__icon');
    if (!toggle || !drawer.contains(toggle)) return;

    const item = toggle.closest('.t4s-menu-item-has-children');
    const list = item && item.parentElement;
    if (!item || !list) return;
    preferredOpenItemByList.set(list, item);

    window.setTimeout(() => {
      if (!item.classList.contains('is--opend')) return;
      showDirectSubmenu(item);

      Array.from(list.children).forEach((sibling) => {
        if (sibling === item || !sibling.classList || !sibling.classList.contains('is--opend')) return;
        closeMenuItem(sibling);
      });
    }, 180);
  }, true);

  const enforceSingleOpen = (drawer) => {
    drawer.querySelectorAll('.t4s-mb__menu, .t4s-sub-menu, .t4s-sub-sub-menu, .t4s-sub-sub-sub-menu').forEach((list) => {
      const openItems = Array.from(list.children).filter((child) => child.classList && child.classList.contains('is--opend'));
      if (openItems.length < 1) return;
      if (openItems.length === 1) {
        showDirectSubmenu(openItems[0]);
        return;
      }

      const preferredOpenItem = preferredOpenItemByList.get(list);
      const itemToKeep = openItems.includes(preferredOpenItem)
        ? preferredOpenItem
        : openItems[openItems.length - 1];

      showDirectSubmenu(itemToKeep);
      openItems.forEach((openItem) => {
        if (openItem !== itemToKeep) closeMenuItem(openItem);
      });
    });
  };

  const observeDrawer = (drawer) => {
    if (drawer.dataset.jockboxAccordionObserved === 'true') return;
    drawer.dataset.jockboxAccordionObserved = 'true';

    const observer = new MutationObserver(() => enforceSingleOpen(drawer));
    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });
  };

  const observeDrawers = () => {
    document.querySelectorAll('.yo-mobile-drawer').forEach(observeDrawer);
  };

  observeDrawers();
  document.addEventListener('shopify:section:load', observeDrawers);
  new MutationObserver(observeDrawers).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
